import { getDeltaSeconds, getUtcNow } from 'utils/utils'
import { useAppSelector } from './redux-hooks'

const checkExpiresAt = (expiresAt: number): boolean => {
  const minDelta = 5 * 60
  return getDeltaSeconds(new Date(expiresAt), getUtcNow()) > minDelta
}

export function useAuth() {
  const { token, expiresAt } = useAppSelector((state) => state.user)

  return {
    isAuth: !!token && expiresAt && checkExpiresAt(expiresAt),
    token,
  }
}
